import { ScoreTrends, ScoreTrendsPayload } from './trendTypes';
import { isExcludedAnalyticsEmail } from '../../utils/excludedAnalyticsEmails';

/**
 * Excludes internal staff accounts from a /admin/statistics/score-trends
 * response before it reaches state. Every list is guarded (`|| []`,
 * optional chaining on the nested objects) rather than assumed present —
 * unlike the rest of `ScoreTrends`, this is a live API response cast to a
 * type, not something actually validated at runtime, so a partial payload
 * must degrade to an empty list rather than throw. A throw here happens
 * inside a try/catch that only logs, so previously a partial payload meant
 * the score-trends chart silently rendered nothing with no visible error.
 */
export function filterScoreTrends(data: ScoreTrendsPayload): ScoreTrends {
  return {
    ...data,
    availableReps: (data.availableReps || []).filter((r) => !isExcludedAnalyticsEmail(r.userEmail)),
    alertTrends: {
      ...(data.alertTrends || {}),
      reps: (data.alertTrends?.reps || []).filter((r) => !isExcludedAnalyticsEmail(r.userEmail)),
    },
    playbookTrends: {
      ...(data.playbookTrends || {}),
      reps: (data.playbookTrends?.reps || []).filter((r) => !isExcludedAnalyticsEmail(r.userEmail)),
    },
  };
}
